<template>
  <v-row class="flex-sm-row-reverse" :key="'nomodule'">
    <v-col cols="12" sm="6" lg="8">
      <v-row class="flex-column">
        <v-col>
          <jump-start-video
            v-for="video of videos"
            :key="'video' + video.link"
            :video="video"
          ></jump-start-video>
        </v-col>
      </v-row>
    </v-col>

    <v-col cols="12" sm="6" lg="4">
      <v-row class="flex-column">
        <slot></slot>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import JumpStartVideo from './Video.vue';

export default {
  name: 'StartPage',
  components: { JumpStartVideo },
  props: ['videos'],
}
</script>

<style scoped lang="scss">
.video-container {
  padding: 0 0 0 0;
  position:relative;
}

.wi-video {
  width: 520px;
  height: 300px;
}
</style>